import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cyclops-header',
  templateUrl: './cyclops-header.component.html',
  styleUrls: ['./cyclops-header.component.scss']
})
export class cyclopsHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  header = 
    { 
      tagLine1:"Cyclops",
      tagLine2:"DELIVERS MISSION-READY DEFENSE SOLUTIONS",
      description:"From UAV operations and tactical communications to surveillance systems and export consulting — we equip governments and defense agencies with scalable, ITAR-compliant capabilities across the MENA region and beyond . We help our partners move faster, adapt faster, and operate with precision."

    }
    // { 
    //   tagLine1:"Cyclops",
    //   tagLine2:"delivers advanced defense services across tactical communications, surveillance integration, and AI-enabled support. We help military and government clients move fast, adapt faster, and operate with precision.",
      

    // },  
  
  
  headercarouselOptions= {
    items: 1,
    margin: 0,
    autoHeight: true,
    nav: false,
    autoplay: false,
    slideSpeed: 300,
    paginationSpeed: 400,
    loop: true,
  }
}
